import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { FaTachometerAlt, FaTrophy, FaFire, FaBars, FaChevronLeft, FaHandPaper, FaArrowLeft, FaPaperPlane, FaCrown, FaQuestionCircle, FaFlask, FaGift } from 'react-icons/fa';
import logoImage from '../SlapGenerator/images/piersslap.png';
import CustomSelectRadixAccount from './CustomSelectRadixAccount';
// Styling handled by Tailwind in globals.css (imported in Layout.js)

const Sidebar = ({ setActivePage, isMobileOpen, closeSidebar }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [isExpanded, setIsExpanded] = useState(true);

  // Get current active page based on URL
  const getActivePageFromPath = () => {
    const path = location.pathname;
    if (path === '/dckslap' || path === '/dckslap/homepage') {
      return 'dashboard';
    } else if (path === '/dckslap/slapgenerator') {
      return 'generator';
    } else if (path === '/dckslap/leaderboard') {
      return 'leaderboard';
    } else if (path === '/dckslap/achievements') {
      return 'achievements';
    } else if (path === '/dckslap/secret-machine') {
      return 'secret-machine';
    } else if (path === '/dckslap/sendslap') {
      return 'sendslap';
    } else if (path === '/dckslap/howtoplay') {
      return 'howtoplay';
    } else if (path === '/dckslap/candyshop') {
      return 'candyshop';
    } else if (path === '/dckslap/candywrapper') {
      return 'candywrapper';
    } else if (path === '/dckslap/viplounge') {
      return 'viplounge';
    } else if (path === '/dckslap/candycombiner') {
      return 'candycombiner';
    }
    return 'dashboard';
  };

  const currentActivePage = getActivePageFromPath();

  const menuItems = [
    { name: 'Dashboard', icon: <FaTachometerAlt />, page: 'dashboard' },
    { name: 'Slap Generator', icon: <FaHandPaper />, page: 'generator' },
    { name: 'Send Slap', icon: <FaPaperPlane />, page: 'sendslap' },
    { name: 'Candy Shop', icon: <FaFire />, page: 'candyshop' },
    { name: 'Candy Wrapper', icon: <FaGift />, page: 'candywrapper', badgeText: 'LIVE', badgeClassName: 'new-badge--wrapper' },
    { name: 'VIP Lounge', icon: <FaCrown />, page: 'viplounge' },
    { name: 'Candy Combiner', icon: <FaFlask />, page: 'candycombiner', badgeText: 'SOON' },
    { name: 'Leaderboard', icon: <FaTrophy />, page: 'leaderboard' },
    { name: 'How to Play', icon: <FaQuestionCircle />, page: 'howtoplay' },
  ];

  const handleMenuClick = (page, event) => {
    // Prevent multiple rapid clicks
    event.preventDefault();
    event.stopPropagation();

    setActivePage(page);
    if (closeSidebar) {
      closeSidebar();
    }
  };

  const handleToggleSidebar = (e) => {
    e.preventDefault();
    e.stopPropagation();

    // Prevent multiple rapid toggles
    if (e.detail > 1) return; // Ignore double/triple clicks

    setIsExpanded(!isExpanded);
  };

  const handleSidebarClick = () => {
    if (!isExpanded) {
      setIsExpanded(true);
    }
  };

  return (
    <nav
      className={`sidebar ${isExpanded ? 'expanded' : 'collapsed'} ${isMobileOpen ? 'mobile-open' : ''}`}
      onClick={handleSidebarClick}
    >
      <div className="sidebar-toggle" onClick={handleToggleSidebar}>
        {isExpanded ? <FaChevronLeft /> : <FaBars />}
      </div>
      <div className="sidebar-logo">
        <img src={logoImage} alt="DCKSLAP" className="logo-image" />
      </div>
      <ul>
        {menuItems.map(item => (
          <li
            key={item.name}
            onClick={(e) => handleMenuClick(item.page, e)}
            className={`${currentActivePage === item.page ? 'active' : ''} ${item.badgeText ? 'new-feature' : ''}`}
          >
            <button type="button" className="sidebar-nav-button">
              {item.icon}
              <span className="link-text">{item.name}</span>
              {item.badgeText && (
                <span className={`new-badge${item.badgeClassName ? ` ${item.badgeClassName}` : ''}`}>
                  {item.badgeText}
                </span>
              )}
            </button>
          </li>
        ))}
      </ul>
      <div className="sidebar-bottom">
        <div className="custom-select-wrapper">
          <CustomSelectRadixAccount />
        </div>
        <div className="back-to-reddicks" onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          navigate('/');
        }}>
          <FaArrowLeft />
          <span className="link-text">Back to Reddicks</span>
        </div>
      </div>
    </nav>
  );
};

export default Sidebar;
